import * as Yup from 'yup';

const state = Yup.string().when('isRm', {
  is: true,
  then: Yup.string().required('State is required'),
});

export default state;
